import React from 'react';
import {useTheme} from '../contexts/ThemeContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiHome,FiUsers,FiTrendingUp,FiShield,FiArrowRight,FiSun,FiMoon,FiCheck}=FiIcons;

const LandingPage=({setCurrentView})=> {
  const {isDark,toggleTheme}=useTheme();

  const features=[ 
    {icon: FiHome,title: "Gestione Immobili",description: "Sistema completo per la gestione delle segnalazioni immobiliari con foto e dettagli"},
    {icon: FiUsers,title: "Network di Segnalatori",description: "Collabora con una rete di segnalatori qualificati per trovare le migliori opportunità"},
    {icon: FiTrendingUp,title: "Commissioni Garantite",description: "Guadagna commissioni per ogni segnalazione che si trasforma in vendita"},
    {icon: FiShield,title: "Sicurezza Totale",description: "Piattaforma sicura e affidabile per proteggere i tuoi dati e le tue transazioni"} 
  ];

  const stats=[ 
    {number: "500+",label: "Immobili Venduti"},
    {number: "150+",label: "Segnalatori Attivi"},
    {number: "25+",label: "Agenzie Partner"},
    {number: "98%",label: "Soddisfazione Cliente"} 
  ];

  return ( 
    <div className={`min-h-screen transition-colors ${isDark ? 'bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900' : 'bg-gradient-to-br from-blue-50 via-white to-blue-100'}`}> 
      {/* Header */} 
      <header className={`${isDark ? 'bg-gray-800/50 backdrop-blur-sm' : 'bg-white/80 backdrop-blur-sm'} fixed w-full top-0 z-50 border-b ${isDark ? 'border-gray-700' : 'border-gray-200'}`}> 
        <div className="container mx-auto px-4 py-4"> 
          <div className="flex justify-between items-center"> 
            <div className="flex items-center space-x-3"> 
              <div className={`p-2 rounded-xl ${isDark ? 'bg-blue-800' : 'bg-blue-600'}`}> 
                <SafeIcon icon={FiHome} className="text-2xl text-white" /> 
              </div> 
              <div> 
                <h1 className={`text-2xl font-bold ${isDark ? 'text-white' : 'text-gray-800'}`}> 
                  HomeScout 
                </h1> 
                <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}> 
                  Gestione Immobiliare Professionale 
                </p> 
              </div> 
            </div> 
            <div className="flex items-center space-x-4"> 
              <button onClick={toggleTheme} className={`p-3 rounded-xl transition-colors ${isDark ? 'bg-gray-700 hover:bg-gray-600 text-gray-300' : 'bg-gray-100 hover:bg-gray-200 text-gray-600'}`} title={isDark ? 'Modalità chiara' : 'Modalità scura'} > 
                <SafeIcon icon={isDark ? FiSun : FiMoon} className="w-5 h-5" /> 
              </button> 
              <button onClick={()=> setCurrentView('login')} className={`px-6 py-3 rounded-xl font-semibold transition-colors ${isDark ? 'bg-gray-700 text-white hover:bg-gray-600' : 'bg-gray-200 text-gray-800 hover:bg-gray-300'}`} > 
                Accedi 
              </button> 
              <button onClick={()=> setCurrentView('register')} className="px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl font-semibold hover:from-blue-700 hover:to-blue-800 transition-all transform hover:scale-105 shadow-lg" > 
                Registrati 
              </button> 
            </div> 
          </div> 
        </div> 
      </header> 

      {/* Hero Section */} 
      <section className="pt-32 pb-20"> 
        <div className="container mx-auto px-4"> 
          <div className="text-center max-w-4xl mx-auto"> 
            <h2 className={`text-5xl md:text-6xl font-bold mb-8 leading-tight ${isDark ? 'text-white' : 'text-gray-800'}`}> 
              Il Futuro del 
              <span className="bg-gradient-to-r from-blue-600 to-blue-800 bg-clip-text text-transparent"> 
                {" "}Real Estate 
              </span> 
            </h2> 
            <p className={`text-xl md:text-2xl mb-12 leading-relaxed ${isDark ? 'text-gray-300' : 'text-gray-600'}`}> 
              Connetti segnalatori,agenti e proprietari in un'unica piattaforma professionale. Guadagna commissioni,gestisci segnalazioni e fai crescere il tuo business immobiliare. 
            </p> 
            <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-16"> 
              <button onClick={()=> setCurrentView('register')} className="flex items-center space-x-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white px-8 py-4 rounded-2xl font-bold text-lg hover:from-blue-700 hover:to-blue-800 transition-all duration-200 transform hover:scale-105 shadow-xl" > 
                <span>Inizia Gratis</span> 
                <SafeIcon icon={FiArrowRight} className="w-6 h-6" /> 
              </button> 
              <button onClick={()=> setCurrentView('login')} className={`flex items-center space-x-3 px-8 py-4 rounded-2xl font-bold text-lg transition-colors ${isDark ? 'bg-gray-700 text-white hover:bg-gray-600' : 'bg-white text-gray-800 hover:bg-gray-100 shadow-lg'}`} > 
                <span>Ho già un account</span> 
              </button> 
            </div> 

            {/* Stats */} 
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8"> 
              {stats.map((stat,index)=> ( 
                <div key={index} className={`text-center p-6 rounded-2xl ${isDark ? 'bg-gray-800/50' : 'bg-white/80'} backdrop-blur-sm shadow-lg`}> 
                  <div className={`text-3xl font-bold mb-2 ${isDark ? 'text-blue-400' : 'text-blue-600'}`}> 
                    {stat.number} 
                  </div> 
                  <div className={`text-sm font-medium ${isDark ? 'text-gray-300' : 'text-gray-600'}`}> 
                    {stat.label} 
                  </div> 
                </div> 
              ))} 
            </div> 
          </div> 
        </div> 
      </section> 

      {/* Features Section */} 
      <section className={`py-20 ${isDark ? 'bg-gray-800/30' : 'bg-gray-50/80'} backdrop-blur-sm`}> 
        <div className="container mx-auto px-4"> 
          <div className="text-center mb-16"> 
            <h3 className={`text-4xl font-bold mb-6 ${isDark ? 'text-white' : 'text-gray-800'}`}> 
              Perché Scegliere HomeScout? 
            </h3> 
            <p className={`text-xl ${isDark ? 'text-gray-300' : 'text-gray-600'}`}> 
              La piattaforma completa per il settore immobiliare 
            </p> 
          </div> 
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8"> 
            {features.map((feature,index)=> ( 
              <div key={index} className={`p-8 rounded-2xl text-center transition-all hover:scale-105 ${isDark ? 'bg-gray-800 hover:bg-gray-700' : 'bg-white hover:shadow-xl'} shadow-lg`}> 
                <div className={`inline-flex p-4 rounded-2xl mb-6 ${isDark ? 'bg-blue-800' : 'bg-blue-100'}`}> 
                  <SafeIcon icon={feature.icon} className={`w-8 h-8 ${isDark ? 'text-blue-300' : 'text-blue-600'}`} /> 
                </div> 
                <h4 className={`text-xl font-bold mb-4 ${isDark ? 'text-white' : 'text-gray-800'}`}> 
                  {feature.title} 
                </h4> 
                <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} leading-relaxed`}> 
                  {feature.description} 
                </p> 
              </div> 
            ))} 
          </div> 
        </div> 
      </section> 

      {/* How it Works */} 
      <section className="py-20"> 
        <div className="container mx-auto px-4"> 
          <div className="text-center mb-16"> 
            <h3 className={`text-4xl font-bold mb-6 ${isDark ? 'text-white' : 'text-gray-800'}`}> 
              Come Funziona 
            </h3> 
            <p className={`text-xl ${isDark ? 'text-gray-300' : 'text-gray-600'}`}> 
              Tre semplici passi per iniziare a guadagnare 
            </p> 
          </div> 
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12"> 
            {[ 
              {step: "01",title: "Registrati",description: "Crea il tuo account gratuito e scegli il tuo ruolo: segnalatore o agenzia"},
              {step: "02",title: "Segnala Immobili",description: "Trova immobili in vendita e crea segnalazioni complete con foto e dettagli"},
              {step: "03",title: "Guadagna",description: "Ricevi commissioni per ogni segnalazione che si trasforma in vendita"} 
            ].map((item,index)=> ( 
              <div key={index} className="text-center"> 
                <div className={`inline-flex w-20 h-20 items-center justify-center rounded-full mb-6 ${isDark ? 'bg-gradient-to-r from-blue-800 to-blue-900' : 'bg-gradient-to-r from-blue-600 to-blue-700'} text-white text-2xl font-bold`}> 
                  {item.step} 
                </div> 
                <h4 className={`text-2xl font-bold mb-4 ${isDark ? 'text-white' : 'text-gray-800'}`}> 
                  {item.title} 
                </h4> 
                <p className={`text-lg ${isDark ? 'text-gray-300' : 'text-gray-600'} leading-relaxed`}> 
                  {item.description} 
                </p> 
              </div> 
            ))} 
          </div> 
        </div> 
      </section> 

      {/* CTA Section */} 
      <section className="py-20"> 
        <div className="container mx-auto px-4"> 
          <div className={`text-center p-12 rounded-3xl ${isDark ? 'bg-gradient-to-r from-blue-800 to-blue-900' : 'bg-gradient-to-r from-blue-600 to-blue-700'} text-white`}> 
            <h3 className="text-4xl font-bold mb-6"> 
              Pronto a Trasformare il Tuo Business? 
            </h3> 
            <p className="text-xl mb-8 opacity-90"> 
              Unisciti a centinaia di professionisti che hanno già scelto HomeScout 
            </p> 
            <div className="flex flex-col sm:flex-row gap-6 justify-center items-center"> 
              <button onClick={()=> setCurrentView('register')} className="bg-white text-blue-600 px-8 py-4 rounded-2xl font-bold text-lg hover:bg-gray-100 transition-all transform hover:scale-105 shadow-lg" > 
                Inizia Subito - È Gratis 
              </button> 
              <div className="flex items-center space-x-2 text-blue-100"> 
                <SafeIcon icon={FiCheck} className="w-5 h-5" /> 
                <span>Nessun costo iniziale</span> 
              </div> 
            </div> 
          </div> 
        </div> 
      </section> 

      {/* Footer */} 
      <footer className={`py-12 ${isDark ? 'bg-gray-800 border-gray-700' : 'bg-gray-100 border-gray-200'} border-t`}> 
        <div className="container mx-auto px-4"> 
          <div className="flex flex-col md:flex-row justify-between items-start mb-8"> 
            <div className="flex items-center space-x-3 mb-6 md:mb-0"> 
              <div className={`p-2 rounded-xl ${isDark ? 'bg-blue-800' : 'bg-blue-600'}`}> 
                <SafeIcon icon={FiHome} className="text-xl text-white" /> 
              </div> 
              <div> 
                <div className={`text-lg font-bold ${isDark ? 'text-white' : 'text-gray-800'}`}> 
                  HomeScout 
                </div> 
                <div className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}> 
                  Gestione Immobiliare Professionale 
                </div> 
              </div> 
            </div> 
          </div> 
          
          {/* Company Information */}
          <div className={`border-t ${isDark ? 'border-gray-700' : 'border-gray-200'} pt-8`}>
            <div className={`text-center space-y-3 ${isDark ? 'text-gray-400' : 'text-gray-600'} text-sm leading-relaxed`}>
              <p className="font-semibold">
                HomeScout © 2025 di Dynamic-Web Srls – P.Iva 03034040356 – Tutti i diritti sono riservati
              </p>
              <p>
                Rag. Sociale: DYNAMIC-WEB SRLS - SOCIETA' A RESPONSABILITA' LIMITATA SEMPLIFICATA
              </p>
              <p className="pt-2 border-t border-gray-300 dark:border-gray-600">
                Questa applicazione è stata realizzata da Dynamic-Web Srls e utilizza Supabase per l'archiviazione sicura dei dati.
              </p>
            </div>
          </div>
        </div> 
      </footer> 
    </div> 
  );
};

export default LandingPage;